import axios from '../api/axiosInstance';

export const fetchDeliveryBoys = (params) => {
  return axios.get('/delivery-boys', { params });
};

export const createDeliveryBoy = (data) => {
  return axios.post('/delivery-boys', data);
};

export const updateDeliveryBoy = (id, data) => {
  return axios.put(`/delivery-boys/${id}`, data);
};

export const updateDeliveryBoyStatus = (id, status) => {
  return axios.patch(`/delivery-boys/${id}/status`, { status });
};

export const deleteDeliveryBoy = (id, reason) => {
  return axios.delete(`/delivery-boys/${id}`, { data: { reason } });
};
